import React, { memo } from 'react';
import styled from 'styled-components';
import { smallMediaQuery, mediumMediaQuery } from '../../../common/utilities/sizeHelpers';

interface MediaNavProps {
    isActive: boolean;
    linkName: string;
    linkUrl: string;
    linkToWeb2?: boolean;
}

export const PageSubNavLink = memo((
    {
        linkName,
        linkUrl,
        isActive,
        linkToWeb2 = false
    }: MediaNavProps
) => {
        if(linkToWeb2) {
            return <SubNavLink target='_self' href={linkUrl} isActive={isActive}>
                {linkName}
            </SubNavLink>
        } else {
            return <SubNavLink href={linkUrl} isActive={isActive}>
                {linkName}
            </SubNavLink>
        }
});

PageSubNavLink.displayName = 'PageSubNavLink';

interface SubNavLinkProps {
    isActive: boolean;
}

const SubNavLink = styled.a<SubNavLinkProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 11px 12px;
    font-size: 16px;
    width: auto;
    text-decoration: none;
    color: #ffffff;
    transition: color .15s ease-in-out, border-bottom-color .15s ease-in-out;
    font-weight: ${({ isActive }) => isActive ? '600' : '400'};
    border-bottom: ${({ isActive }) => isActive
        ? '3px solid rgba(255, 255, 255, 0.9)'
        : '3px solid rgba(255, 255, 255, 0.2)'};

    &:hover {
        color: rgba(255, 255, 255, .9);
        border-bottom-color: rgba(255, 255, 255, .5);
    }
    @media ${mediumMediaQuery} {
        padding: 12px 25px;
        font-size: 18px;
    }
    @media ${smallMediaQuery} {
        font-size: 15px;
        padding: 13px 12px;
        width: 50%;
    }
`;
